import React from 'react';
import { MapPin, Navigation } from 'lucide-react';
import { Modal } from '../ui/Modal';

/**
 * Bottom-sheet-style modal offering Google Maps + Waze navigation options
 * for a business location. Parses the `location` JSON-like string (which
 * may use single quotes) defensively and renders nothing on parse failure.
 */
export function BusinessLocationModal({ isOpen, locationString, onClose }) {
    if (!isOpen || !locationString) return null;

    let parsed;
    try {
        parsed = JSON.parse(locationString.replaceAll("'", '"'));
    } catch {
        return null;
    }
    if (!parsed?.lat || !parsed?.lng) return null;

    const { lat, lng } = parsed;
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
    const wazeUrl = `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`;

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="sm" title="מיקום העסק" subtitle="בחרו אפליקציית ניווט">
            <div className="flex flex-col items-center gap-5">
                <div className="w-16 h-16 rounded-2xl bg-brand-50 text-brand-700 ring-1 ring-brand-100 inline-flex items-center justify-center">
                    <MapPin className="w-8 h-8" strokeWidth={1.75} />
                </div>

                <div className="w-full flex flex-col gap-3">
                    <a
                        href={googleMapsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center gap-3 bg-info-500 hover:bg-info-600 text-ink-inverse py-3 px-6 rounded-lg font-bold shadow-sm hover:shadow-md transition-[background-color,box-shadow,transform] duration-200 ease-smooth active:scale-[0.98]"
                    >
                        <Navigation className="w-5 h-5" strokeWidth={2} />
                        <span>Google Maps</span>
                    </a>
                    <a
                        href={wazeUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center gap-3 bg-info-500 hover:bg-info-600 text-ink-inverse py-3 px-6 rounded-lg font-bold shadow-sm hover:shadow-md transition-[background-color,box-shadow,transform] duration-200 ease-smooth active:scale-[0.98]"
                    >
                        <Navigation className="w-5 h-5" strokeWidth={2} />
                        <span>Waze</span>
                    </a>
                </div>
            </div>
        </Modal>
    );
}

export default BusinessLocationModal;
